<template>
  <div v-if="!onlyShowDate">
    <div class="row">
      <div class="col">
        <div v-if="showEntite" class="row">
          <div class="col-lg-3 lbl">
            <label>Entité:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="entite"
                :options="entiteLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col">
        <div v-if="showSiteOrigine" class="row">
          <div class="col-lg-3 lbl">
            <label>Site d'origine:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="siteOrigine"
                :options="sitesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div v-if="showGenre" class="row">
          <div class="col-lg-3 lbl">
            <label>Genre:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="genre"
                :options="genresLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div v-if="showNature" class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Nature:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="nature"
                :options="naturesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"/>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

  </div>

  <div class="row">
    <div class="col">
      <div v-if="showDateEntreLe" class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div v-if="showDateEtLe" class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheLoteries",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    showEntite: {
      type: Boolean,
      default: true,
    },
    showSiteOrigine: {
      type: Boolean,
      default: true,
    },
    showGenre: {
      type: Boolean,
      default: true,
    },
    showNature: {
      type: Boolean,
      default: true,
    },
    onlyShowDate: {
      type: Boolean,
      default: false,
    },
    showDateEntreLe: {
      type: Boolean,
      default: true,
    },
    showDateEtLe: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      titre: null,
      entite: null,
      siteOrigine: null,
      genre: null,
      nature: null,
      dateDu: null,
      dateAu: null,

      entiteLibelles: [],
      sitesLibelles: [],
      genresLibelles: [],
      naturesLibelles: [],

      intervenantsLoading: false,
      critereRecherche: {}
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
        this.siteOrigine = res.data.site;
        this.dateDefault();
      });
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 30));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCritereRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRecherche.dateDu = new Date(this.dateDu);
      }

      this.critereRecherche.titre = this.titre;
      this.critereRecherche.entite = this.entite;
      this.critereRecherche.genre = this.genre;
      this.critereRecherche.nature = this.nature;
      this.critereRecherche.siteOrigine = this.siteOrigine;
      return this.critereRecherche;
    },
    imprimer() {
      this.$emit("imprimer");
    },
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("dossier/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genresLibelles = res.data;
            });
      } else {
        this.genre = null;
        this.genresLibelles = [];
        this.siteOrigine = null;
        this.sitesLibelles = [];
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.naturesLibelles = res.data;
            });
      } else {
        this.nature = null;
        this.naturesLibelles = [];
      }
    },
  }
}
</script>